// Intersection Observer for scroll animations
const observerOptions = {
    threshold: 0.2,
    rootMargin: '0px 0px -100px 0px'
};

const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
            observer.unobserve(entry.target);
        }
    });
}, observerOptions);

// Observe all timeline items
document.addEventListener('DOMContentLoaded', () => {
    const timelineItems = document.querySelectorAll('[data-animate]');
    timelineItems.forEach(item => observer.observe(item));

    // Product Gallery Thumbnail Click
    const thumbnails = document.querySelectorAll('.thumbnail');
    const mainImage = document.getElementById('mainImage');

    thumbnails.forEach(thumbnail => {
        thumbnail.addEventListener('click', function() {
            // Only process if it's an actual image thumbnail, not placeholder
            if (this.dataset.image) {
                // Remove active class from all thumbnails
                thumbnails.forEach(t => t.classList.remove('active'));

                // Add active class to clicked thumbnail
                this.classList.add('active');

                // Update main image
                mainImage.src = this.dataset.image;
                mainImage.alt = this.querySelector('img').alt;
            }
        });
    });
});

// Ritual Timeline Interactive Slider
let currentStep = 0;
const totalSteps = 4;

function updateRitualSlider(newStep, direction = 'forward') {
    if (newStep < 0 || newStep >= totalSteps) return;

    const steps = document.querySelectorAll('.ritual-step');
    const navDots = document.querySelectorAll('.ritual-nav-dot');
    const progressBar = document.getElementById('progressBar');
    const prevStepBtn = document.getElementById('prevStepBtn');
    const nextStepBtn = document.getElementById('nextStepBtn');
    const prevArrow = document.getElementById('prevStep');
    const nextArrow = document.getElementById('nextStep');

    // Update current step
    steps[currentStep].classList.remove('active');
    if (direction === 'forward') {
        steps[currentStep].classList.add('exit-left');
    }

    setTimeout(() => {
        steps[currentStep].classList.remove('exit-left');
    }, 500);

    currentStep = newStep;

    // Update active step
    steps[currentStep].classList.add('active');

    // Update navigation dots
    navDots.forEach((dot, index) => {
        if (index === currentStep) {
            dot.classList.add('active');
        } else {
            dot.classList.remove('active');
        }
    });

    // Update progress bar
    progressBar.setAttribute('data-progress', currentStep);

    // Update button states
    prevStepBtn.disabled = currentStep === 0;
    nextStepBtn.disabled = currentStep === totalSteps - 1;
    prevArrow.disabled = currentStep === 0;
    nextArrow.disabled = currentStep === totalSteps - 1;

    // Update button text for last step
    if (currentStep === totalSteps - 1) {
        nextStepBtn.textContent = 'Start Your Ritual ✨';
    } else {
        nextStepBtn.textContent = 'Next →';
    }
}

document.addEventListener('DOMContentLoaded', () => {
    // Next/Previous buttons
    document.getElementById('nextStepBtn').addEventListener('click', () => {
        if (currentStep < totalSteps - 1) {
            updateRitualSlider(currentStep + 1, 'forward');
        }
    });

    document.getElementById('prevStepBtn').addEventListener('click', () => {
        if (currentStep > 0) {
            updateRitualSlider(currentStep - 1, 'backward');
        }
    });

    // Arrow buttons
    document.getElementById('nextStep').addEventListener('click', () => {
        if (currentStep < totalSteps - 1) {
            updateRitualSlider(currentStep + 1, 'forward');
        }
    });

    document.getElementById('prevStep').addEventListener('click', () => {
        if (currentStep > 0) {
            updateRitualSlider(currentStep - 1, 'backward');
        }
    });

    // Navigation dots
    document.querySelectorAll('.ritual-nav-dot').forEach((dot, index) => {
        dot.addEventListener('click', () => {
            const direction = index > currentStep ? 'forward' : 'backward';
            updateRitualSlider(index, direction);
        });
    });

    // Initialize
    updateRitualSlider(0);
});

// Update cart count dynamically when items are added
function updateCartCount() {
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            const cartCountElement = document.getElementById('cartCount');
            const cartLink = document.querySelector('.custom-cart-link');

            if (cartCountElement) {
                cartCountElement.textContent = cart.item_count;

                // Hide count badge if cart is empty
                if (cart.item_count === 0) {
                    cartLink.setAttribute('data-cart-empty', 'true');
                } else {
                    cartLink.setAttribute('data-cart-empty', 'false');
                }
            }
        })
        .catch(error => console.error('Error fetching cart:', error));
}

// Update cart count on page load
document.addEventListener('DOMContentLoaded', updateCartCount);

// Listen for add to cart events and redirect to cart
document.addEventListener('DOMContentLoaded', () => {
    const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');

    addToCartForms.forEach(form => {
        form.addEventListener('submit', function(e) {
            e.preventDefault();

            const formData = new FormData(this);

            fetch('/cart/add.js', {
                method: 'POST',
                body: formData
            })
            .then(response => response.json())
            .then(data => {
                // Update cart count
                updateCartCount();

                // Redirect to cart page instead of showing popup
                window.location.href = '/cart';
            })
            .catch(error => {
                console.error('Error adding to cart:', error);
                alert('Error adding to cart. Please try again.');
            });
        });
    });
});
